// Questionnaire/Questionnaire.tsx
import React, {useEffect, useState} from 'react';
import {Navigate, Route, Routes, useLocation, useNavigate} from 'react-router-dom';
import TabButton from "Core/components/elements/Tabs/TabButton";
import {FC, FRC} from "WideLayout/Layouts";
import {Box} from "@mui/material";
import {useTheme} from "Theme/ThemeContext";
import GeneralInfo from "../Questionnaire/GeneralInfo";
import PersonalInfo from "../Questionnaire/PersonalInfo";
import Head from "Core/components/Head";
import {DOMAIN_URL} from "Auth/axiosConfig";
import FriendlyVideo from "Modules/FriendlyVideo";

interface Step {
    name: string;
    path: string;
}

const Questionnaire: React.FC = () => {
    const [currentStep, setCurrentStep] = useState<number>(1);
    const {plt} = useTheme();
    const navigate = useNavigate();
    const location = useLocation();

    const steps: Step[] = [
        {name: 'Общее', path: '/questionnaire/general'},
        {name: 'Личное', path: '/questionnaire/personal'},
        {name: 'Психолог', path: '/questionnaire/psychologists'},
    ];

    useEffect(() => {
        const currentPath = location.pathname;
        const stepIndex = steps.findIndex(step => currentPath.startsWith(step.path));
        if (stepIndex !== -1) {
            setCurrentStep(stepIndex + 1);
        } else {
            setCurrentStep(1);
        }
    }, [location.pathname, steps]);

    const handleStepClick = (index: number, path: string) => {
        // Если пользователь на первом шаге ("Общее") и нажимает на второй ("Личное"),
        // то сначала отправляем форму (как "Далее"), а потом переключаем вкладку.
        if (currentStep === 1 && index === 1) {
            const formElement = document.getElementById('generalInfoForm') as HTMLFormElement | null;
            console.log(formElement)
            if (formElement) {
                formElement.requestSubmit();
            }
        }
        if (currentStep === 1 && (index === 1 || index === 2)) {
            const formElement = document.getElementById("generalInfoForm") as HTMLFormElement | null;
            if (formElement) {
                formElement.requestSubmit();
            }
        } else {
            setCurrentStep(index + 1);
            navigate(path);
        }
    };

    return (
        <FC maxH={'100%'} minH={'100%'}>
            <Head
                title={'Анкета | Лайф Хелп'}
                description={'Помощь квалифицированных психологов от сервиса Лайф Хелп'}
                robots={'noindex, nofollow'}
                canonicalUrl={`${DOMAIN_URL}/questionnaire/*`}
            />
            <FRC g={1} mb={1} px={2}>
                {steps.map((step, index) => (
                    <TabButton
                        key={index}
                        active={currentStep === index + 1}
                        onClick={() => handleStepClick(index, step.path)}
                        textSx={{
                            padding: {
                                xs: '0 .6rem 0.2rem .6rem',
                                md: '0 1rem 0.2rem 1rem',
                            },
                            fontSize: {
                                xs: '1rem',
                                md: '1.3rem',
                            },
                        }}
                    >
                        {step.name}
                    </TabButton>
                ))}
            </FRC>
            <FC pos={'relative'} grow maxH={'100%'} minH={'100%'}>
                <Box
                    position={'absolute'}
                    zIndex={9}
                    top={0}
                    left={0}
                    width={'100%'}
                    height={'100%'}
                    sx={{
                        pointerEvents: 'none',
                        background: `linear-gradient(180deg, ${plt.bg.primary} 0%, rgba(0,0,0,0) 2%, rgba(0,0,0,0) 100%)`
                    }}
                />
                <Routes>
                    <Route path="/" element={<Navigate to="general" replace/>}/>
                    <Route path="general" element={<GeneralInfo/>}/>
                    <Route path="personal" element={<PersonalInfo/>}/>
                    <Route path="psychologists" element={<Navigate to={'/psychologists'}/>}/>
                </Routes>
            </FC>
            <FriendlyVideo videoSrc={'/static/psychology/video/questionnaire.mp4'}/>
        </FC>
    );
};

export default Questionnaire;
